import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { IndexComponent as AdminIndexComponent } from './admin/index/index.component';
import { WorkspaceComponent } from './admin/workspace/workspace.component';
import { CaseDetailComponent } from './admin/case-detail/case-detail.component';
import { UploadListComponent } from './admin/upload-list/upload-list.component';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { EfComponent } from './ef/ef.component';
import { ReportComponent } from './admin/report/report.component';
import { PrintComponent as ReportPrintComponent } from './admin/report/print/print.component';
import { DiagnosisComponent as DiagnosisSettingComponent } from './admin/setting/template/diagnosis/diagnosis.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  // login
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'admin',
    component: AdminIndexComponent,
    children: [
      {
        path: 'workbench',
        component: WorkspaceComponent,
      },
      {
        path: 'upload/list',
        component: UploadListComponent,
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'report/print/:id',
        component: ReportPrintComponent,
      },
      {
        path: 'setting/diagnosis',
        component: DiagnosisSettingComponent,
      },
    ],
  },
  {
    path: 'admin/case/detail/:id',
    component: CaseDetailComponent,
  },
  {
    path: 'ef/:id',
    component: EfComponent,
  },
  {
    path: 'admin/report/:id',
    component: ReportComponent,
  },
];
